module.exports = __webpack_public_path__ + "img/Icon_info_Minus.60468eb2.png";